angular.module("leanlaw").filter("monthNoZero", [() => {
  return function (months) {
    if (!months || months === 0) {
      return "-";
    }
    return months;
  };
}]);